/**
 * @file edit-purchase-order.tsx
 * @deprecated Copied to app/modules/procurement/pages/po-management/edit-purchase-order.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/po-management/edit-purchase-order
 * @description Form component for editing existing purchase orders. Loads PO data from
 *   location state or API and allows modification of vendor, products, quantities, and
 *   delivery dates (if status permits). Fields are conditionally locked based on PO
 *   shipment status to enforce business rules. Supports add/remove product rows and
 *   form validation before submission.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo [P2] Implement per-index product pagination
 *   - Support fetching different products per row (sellerProducts[index])
 *   - Each row can have independent scroll pagination for variants
 *   - Call fetchProduct(sellerId, page, limit, search, index) per row
 *   - Currently: Basic fetch without per-row state management
 *   - Reference: uprocure-admin lines 637, 714, 833
 *
 * @todo [P2] Add comprehensive error handling
 *   - Wrap fetchVendorsList, fetchProduct, fetchProductPrice in try/catch
 *   - Show error toasts for API failures
 *   - Reset loading flags in finally blocks
 *   - Prevent invalid state transitions on errors
 *   - Currently: Minimal error handling - no try/catch blocks
 *   - Reference: uprocure-admin lines 125-201 error structure
 *
 * @todo [P2] Implement debounce for product search
 *   - Add useDebounce hook for handleProductInputChange
 *   - Delay product search by 300-500ms to reduce API calls
 *   - Reference: uprocure-admin lines 642, add-purchase-order.tsx debounce pattern
 *
 * @todo [P3] Add field-level status locks
 *   - Disable vendor/product/delivery date fields based on shipment status
 *   - Lock fields if status !== 'pending' (per business rules)
 *   - Show UI hints for why fields are disabled
 *   - Reference: uprocure-admin lines 900-950 (status-based disabled logic)
 *
 * @todo [P3] Cleanup: Remove unused dummy data structures
 *   - Delete deliveryAddresses array
 *   - Use API responses instead
 *   - Reduce component boilerplate once P1 APIs are implemented
 *
 * @todo [P2] Restore low-stock forecast parity from uprocure edit flow
 *   - Fetch low-stock/forecast payload per selected variant during prefill and manual changes
 *   - Bind forecastedDaysData to each row and show warning UI near quantity inputs
 *   - Keep warning behavior consistent with add-purchase-order and source uprocure module
 */

import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { CustomSelect } from "../../../custom/Select/CustomSelect";
import GrayCross from "../../../../_admin/assets/media/svg_uTrade/cross-red.svg";
import { useLocation, useNavigate } from "react-router-dom";
import WarningIcon from "../../../../_admin/assets/media/svg_uTrade/error-warning.svg";
import { Fragment, useEffect, useState } from "react";
import clsx from "clsx";
import Loader from "../../../../Global/loader";
import { error } from "../../../../Global/toast";
import APICallService from "../../../../api/apiCallService";
import { PriceCatalog } from "../../../../types";
import {
  manageProduct,
  multipleWarehouse,
  PURCHASEORDER,
  vendor,
} from "../../../../api/apiEndPoints";
import {
  AllSeller,
  CartonWithDozens,
  CartonWithPieces,
  Dozen,
  PAGE_LIMIT,
  Piece,
  SelfTransport,
  Shipping,
  UTradeTransport,
  WarehouseManger,
  WarehouseStorage,
} from "../../../../utils/constants";
// import Loader from '../../../Global/loader';
import Method from "../../../../utils/methods";
import { useAuth } from "../../auth";
import { getKey } from "../../../../Global/history";
import { warehouse as warehouseStoreString } from "../../../../utils/storeString";
import CustomDatePicker from "../../../custom/DateRange/CustomDatePicker";
const EditPurchaseOrder = () => {
  let tempWarehouse: any = getKey(warehouseStoreString.warehouseRef);
  tempWarehouse = JSON.parse(tempWarehouse);
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const [sellerData, setSellerData] = useState<any[]>([]);
  const [uTradeWarehouses, setUTradeWarehouses] = useState<any[]>([]);
  const [uMartWarehouses, setUMartWarehouses] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [productPage, setProductPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [productSearchTerm, setProductSearchTerm] = useState("");
  const [businessActivationDate, setBusinessActivationDate] = useState("");
  const [selectedSeller, setSelectedSeller] = useState<any>(null);
  const [sellerProducts, setSellerProducts] = useState<any>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [shipmentType, setShipmentType] = useState(UTradeTransport);
  const [loading, setLoading] = useState(false);
  const [fetchLoader, setFetchLoader] = useState(false);
  const [productFetchLoader, setProductsFetchLoader] = useState(false);
  const [priceLoading, setPriceLoading] = useState<boolean[]>([]);
  const [umartData, setUmartData] = useState<any>(true);
  const [selectedWarehouse, setSelectedWarehouse] = useState(
    tempWarehouse?._id || tempWarehouse?.reference || "",
  );
  const [warehouseData, setWarehouseData] = useState<any[]>([]);
  const [deliveryDate, setDeliveryDate] = useState<Date | null>(null);
  const [products, setProducts] = useState<
    {
      variant: string;
      quantityTypes: any;
      selectedOption?: any;
    }[]
  >([
    {
      variant: "",
      quantityTypes: [],
    },
  ]);
  const [productValidation, setProductValidation] = useState<
    {
      variant: boolean;
      quantityTypes: boolean;
    }[]
  >([
    {
      variant: false,
      quantityTypes: false,
    },
  ]);

  console.log(state, "state");

  const [totalSellers, setTotalSellers] = useState(0);
  // const [costDetails, setCostDetails] = useState<any>();
  const [initLoader, setInitLoader] = useState(false);
  const [poDetails, setPoDetails] = useState<any>(state || null);
  const selectedSellerObj =
    sellerData && sellerData.length
      ? sellerData.find(
          (s: any) =>
            s._id === selectedSeller?.value ||
            s.reference === selectedSeller?.value,
        )
      : null;

  const fetchSeller = async (
    page: number,
    limit: number,
    search: string = "",
  ) => {
    try {
      setFetchLoader(true);
      let params: any = {
        "status[]": 4,
        pageNo: page,
        limit,
        searchTerm: search,
        needCount: true,
      };

      const businessId =
        poDetails?.business?.reference ||
        poDetails?.business?._id ||
        state?.business?.reference ||
        state?.business?._id;

      if (businessId) {
        params = {
          ...params,
          recordId: businessId,
        };
      }

      const apiService = new APICallService(
        vendor.listVendor,
        params,
        "",
        "",
        "",
        "",
        AllSeller,
      );
      let response = await apiService.callAPI();
      let records = response?.records || [];

      // Some payloads carry `business.reference` while vendor list expects `_id` in recordId.
      // Fallback to unfiltered vendor list so supplier dropdown still loads.
      if (!records.length && businessId && page === 1 && !search) {
        const fallbackParams = { ...params };
        delete fallbackParams.recordId;
        const fallbackService = new APICallService(
          vendor.listVendor,
          fallbackParams,
          "",
          "",
          "",
          "",
          AllSeller,
        );
        const fallbackResponse = await fallbackService.callAPI();
        if (fallbackResponse) {
          response = fallbackResponse;
          records = fallbackResponse.records || [];
        }
      }

      if (response) {
        setTotalSellers(response.total || 0);
        if (page === 1) {
          setSellerData(records);
        } else {
          setSellerData((prev: any[]) => [...prev, ...records]);
        }
        return records;
      }
      return [];
    } catch (error) {
      console.error("Vendor list API failed", error);
      return [];
    } finally {
      setFetchLoader(false);
    }
  };

  const parseDeliveryDate = (rawDate: any): Date | null => {
    if (!rawDate) return null;

    if (typeof rawDate === "string") {
      const ddmmyyyy = rawDate.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (ddmmyyyy) {
        const parsed = new Date(`${ddmmyyyy[3]}-${ddmmyyyy[2]}-${ddmmyyyy[1]}`);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      }
    }

    const parsed = new Date(rawDate);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  };

  const fetchPurchaseOrderInfo = async (id: string) => {
    try {
      if (!id) return null;
      setInitLoader(true);
      const apiService = new APICallService(
        PURCHASEORDER.purchaseOrderInfo,
        id,
      );
      const response = await apiService.callAPI();
      if (response) {
        setPoDetails(response);
        return response;
      }
      return null;
    } catch (error) {
      console.error("Purchase order info API failed", error);
      return null;
    } finally {
      setInitLoader(false);
    }
  };

  const getUTradeWarehouseList = async () => {
    try {
      const apiService = new APICallService(
        multipleWarehouse.listWarehouse,
        "",
        "",
        "",
        "",
        "",
        WarehouseManger,
        tempWarehouse?._id || null,
      );
      const response = await apiService.callAPI();
      if (response) {
        setUTradeWarehouses(response.records || []);
      }
    } catch (error) {
      console.error("Warehouse list API failed", error);
    }
  };

  const getUMartWarehouseList = async () => {
    try {
      // Placeholder for uMart warehouses source in this app.
      setUMartWarehouses([]);
    } catch (error) {
      console.error("uMart warehouse list API failed", error);
    }
  };

  const handleDateChange = (date: Date | null) => {
    setDeliveryDate(date);
  };

  const isDateDisabled = (date: Date) => {
    if (!selectedSellerObj || !selectedSellerObj.workingDays) return true;
    const workingDays = selectedSellerObj.workingDays.map(Number);
    return workingDays.includes(date.getDay());
  };

  const onMenuScrollToBottom = async () => {};
  const onMenuClose = async () => {
    setSearchTerm("");
  };
  const onMenuOpen = async () => {
    setPage(1);
  };
  const handleInputChange = async (inputValue: string) => {
    setPage(1);
    setSearchTerm(inputValue);
    await fetchSeller(1, PAGE_LIMIT, inputValue);
  };

  const handleSeller = async (event: any) => {
    if (event?.value !== selectedSeller?.value) {
      setProductPage(1);
      setSellerProducts([]);
      setProducts([
        {
          variant: "",
          quantityTypes: [],
        },
      ]);
      setPriceLoading([false]);
      await fetchProducts(event.value, 1, PAGE_LIMIT, "");
    }
    setSelectedSeller(event);
  };

  const fetchProductPrice = async (variantId: string, index: number) => {
    try {
      if (!variantId || !selectedWarehouse) {
        return;
      }

      setPriceLoading((prev) => {
        const next = [...prev];
        next[index] = true;
        return next;
      });

      // Cost price comes only from the Price Catalog (active pricing of this warehouse);
      // to change it, change it in the Price Catalog.
      const apiService = new APICallService(
        manageProduct.getPriceCatalogEntry,
        `${variantId}?project=${encodeURIComponent(
          JSON.stringify({ pricing: 1 }),
        )}&warehouse=${selectedWarehouse}`,
        "",
        "",
        "",
        "",
      );
      const response: PriceCatalog | null = await apiService.callAPI();
      const active = (response?.pricing || []).find(
        (p) => p.active && String(p.warehouseId) === String(selectedWarehouse),
      );
      const priceQuantityTypes = (active?.quantityTypes || []).map((q) => ({
        type: q.type,
        purchaseAmount: Number(q.costPrice) > 0 ? Number(q.costPrice) : 0,
      }));

      setProducts((prevProducts) => {
        const updatedProducts = [...prevProducts];
        const currentProduct = { ...updatedProducts[index] };
        currentProduct.quantityTypes = (currentProduct.quantityTypes || []).map(
          (qt: any) => {
            const matched = priceQuantityTypes.find(
              (pqt) => Number(pqt.type) === Number(qt.type),
            );
            // no cost price in the Price Catalog for this qty type: not orderable at a typed price
            if (!matched) {
              return { ...qt, purchaseAmount: 0, price: 0 };
            }

            return {
              ...qt,
              purchaseAmount:
                matched.purchaseAmount != null
                  ? matched.purchaseAmount
                  : qt.purchaseAmount,
              price:
                matched.purchaseAmount != null
                  ? matched.purchaseAmount
                  : qt.price,
            };
          },
        );
        updatedProducts[index] = currentProduct;
        return updatedProducts;
      });
    } catch (error) {
      console.error("Fetch product price failed", error);
    } finally {
      setPriceLoading((prev) => {
        const next = [...prev];
        next[index] = false;
        return next;
      });
    }
  };

  const handleProductSelect = async (event: any, index: number) => {
    let productTemp = [...sellerProducts];
    const filteredArray: any = productTemp.filter(
      (obj: any) => obj._id === event.value,
    );
    if (!filteredArray?.length) {
      return;
    }

    const selectedQuantityTypes = (
      filteredArray[0]?.quantityTypes || []
    ).filter((q: any) => q?.warehouseId === selectedWarehouse);

    const selectedOption = {
      label: (
        <>
          <div className="symbol symbol-30px border me-3">
            <img
              src={filteredArray[0]?.media?.[0]?.url}
              className="object-fit-contain"
              alt=""
            />
          </div>
          <span className="fs-16 fw-600 text-black mb-0">
            {filteredArray[0]?.title?.replace(/\s*\)\s*/g, ")")}
          </span>
        </>
      ),
      value: filteredArray[0]._id,
      title: filteredArray[0].title,
    };

    setProducts((prevProducts) => {
      const temp = [...prevProducts];
      temp[index].quantityTypes = selectedQuantityTypes;
      temp[index].variant = event.value;
      temp[index].selectedOption = selectedOption;
      return temp;
    });
    await fetchProductPrice(event.value, index);
  };
  const fetchProducts = async (
    businessId: string,
    page: number,
    limit: number,
    search: string = "",
  ) => {
    try {
      setProductsFetchLoader(true);
      let params: any = {
        pageNo: page,
        limit,
        searchTerm: search,
        sortKey: "title",
        sortOrder: 1,
        "status[0]": 2,
        state: 2,
        "business[0]": businessId,
        needCount: true,
      };

      const apiService = new APICallService(
        PURCHASEORDER.productListForPurchaseOrder,
        params,
      );
      const response = await apiService.callAPI();
      if (response) {
        const processedRecords = (response.records || []).map((val: any) => ({
          ...val,
          quantityTypes: (val.quantityTypes || []).filter(
            (v: any) => v.warehouseId === selectedWarehouse,
          ),
        }));
        setTotalRecords(response.total || 0);
        if (page === 1) {
          setSellerProducts(processedRecords);
        } else {
          setSellerProducts((prev: any[]) => [...prev, ...processedRecords]);
        }
      }
    } catch (error) {
      console.error("Product list API failed", error);
    } finally {
      setProductsFetchLoader(false);
    }
  };

  const onMenuProductScrollToBottom = async () => {
    if (!(sellerProducts.length === totalRecords)) {
      let tempPage = productPage;
      tempPage = tempPage + 1;
      setProductPage(tempPage);
      if (selectedSeller?.value) {
        await fetchProducts(
          selectedSeller.value,
          tempPage,
          PAGE_LIMIT,
          productSearchTerm,
        );
      }
    }
  };
  const onMenuProductClose = async () => {
    setProductSearchTerm("");
    setProductPage(1);
    if (selectedSeller?.value) {
      await fetchProducts(selectedSeller.value, 1, PAGE_LIMIT, "");
    }
  };
  const onMenuProductOpen = async () => {
    setProductPage(1);
    if (selectedSeller?.value) {
      await fetchProducts(
        selectedSeller.value,
        1,
        PAGE_LIMIT,
        productSearchTerm,
      );
    }
  };
  const handleProductInputChange = async (inputValue: string) => {
    setProductPage(1);
    setProductSearchTerm(inputValue);
    if (selectedSeller?.value) {
      await fetchProducts(selectedSeller.value, 1, PAGE_LIMIT, inputValue);
    }
  };

  const handleQuantityChange = (
    value: string,
    index: number,
    quantityIndex: number,
    type: number,
    field: "stockCount" | "purchaseAmount" = "stockCount",
  ) => {
    let productTemp = [...products];
    let productValidationTemp = [...productValidation];

    productTemp[index] = productTemp[index] || {
      variant: "",
      quantityTypes: [],
    };
    productTemp[index].quantityTypes = productTemp[index].quantityTypes || [];

    let qt = productTemp[index].quantityTypes[quantityIndex];
    if (!qt || qt.type !== type) {
      const existingIdx = productTemp[index].quantityTypes.findIndex(
        (q: any) => q.type === type,
      );
      if (existingIdx !== -1) {
        quantityIndex = existingIdx;
        qt = productTemp[index].quantityTypes[existingIdx];
      } else {
        qt = { type, stockCount: 0, purchaseAmount: 0 };
        productTemp[index].quantityTypes.push(qt);
        quantityIndex = productTemp[index].quantityTypes.length - 1;
      }
    }

    if (field === "stockCount") {
      qt.type = type;
      qt.stockCount = Number(value) || 0;
    } else {
      qt.purchaseAmount = Number(value) || 0;
      qt.price = Number(value) || 0;
    }

    productTemp[index].quantityTypes[quantityIndex] = qt;

    const hasAnyStock = productTemp[index].quantityTypes.some(
      (q: any) => q.stockCount && q.stockCount > 0,
    );
    productValidationTemp[index].quantityTypes = !hasAnyStock;

    const hasAnyPrice = productTemp[index].quantityTypes.some(
      (q: any) => q.purchaseAmount && q.purchaseAmount > 0,
    );
    productValidationTemp[index].variant = !hasAnyPrice;

    setProducts(productTemp);
    setProductValidation(productValidationTemp);
  };
  const handleAddMore = () => {
    let productTemp = [...products];
    let productValidationTemp = [...productValidation];
    const allObjectsHaveQuantityTypeWithStock = productTemp.every((obj: any) =>
      obj.quantityTypes.some(
        (quantityType: any) =>
          quantityType.stockCount && quantityType.stockCount > 0,
      ),
    );
    if (allObjectsHaveQuantityTypeWithStock) {
      productTemp.push({
        variant: "",
        quantityTypes: [],
      });
      setPriceLoading((prev) => [...prev, false]);
      productValidationTemp.push({
        variant: false,
        quantityTypes: false,
      });
    } else {
      productTemp.forEach((product: any, index: number) => {
        const hasStockCountGreaterThanZero = product.quantityTypes.some(
          (quantityType: any) =>
            quantityType.stockCount !== undefined &&
            quantityType.stockCount > 0,
        );
        if (!hasStockCountGreaterThanZero) {
          productValidationTemp[index].quantityTypes = true;
        }
      });
    }
    setProductValidation(productValidationTemp);
    setProducts(productTemp);
  };
  const handleRemove = (indexToRemove: number) => {
    let productTemp = [...products];
    let productValidationTemp = [...productValidation];
    let priceLoadingTemp = [...priceLoading];
    productValidation.splice(indexToRemove, 1);
    productTemp.splice(indexToRemove, 1);
    priceLoadingTemp.splice(indexToRemove, 1);
    setProducts(productTemp);
    setProductValidation(productValidationTemp);
    setPriceLoading(priceLoadingTemp);
  };

  const handleSubmit = async () => {
    const sellerId = selectedSeller?.value;
    const warehouseId =
      poDetails?.warehouse?.reference ||
      poDetails?.warehouse?._id ||
      state?.warehouse?.reference ||
      state?.warehouse?._id ||
      selectedWarehouse;
    const recordId = poDetails?._id || state?._id || state?.id;

    if (!sellerId) {
      error("Supplier is required");
      return;
    }
    if (!warehouseId) {
      error("Warehouse is required");
      return;
    }
    if (!deliveryDate) {
      error("Delivery date is required");
      return;
    }
    if (!recordId) {
      error("Purchase order not found");
      return;
    }

    try {
      setLoading(true);
      let productTemp = [...products];
      let productValidationTemp = [...productValidation];

      const variants = products
        .filter((p: any) => p.variant)
        .map((p: any) => {
          const variantId =
            typeof p.variant === "object"
              ? p.variant?._id || p.variant?.reference || ""
              : p.variant;
          return {
            variant: variantId,
            quantityTypes: (() => {
              const uniqueByType = new Map();
              (p.quantityTypes || []).forEach((q: any) => {
                if (!q) return;
                if (
                  q?.warehouseId &&
                  String(q.warehouseId) !== String(warehouseId)
                ) {
                  return;
                }
                const stockCount = Number(q.stockCount) || 0;
                if (stockCount <= 0) return;
                const typeKey =
                  q.type != null ? q.type.toString() : String(q.type);
                uniqueByType.set(typeKey, {
                  type: typeKey,
                  stockCount,
                  amount: Number(q.amount) || 0,
                  discountAmt: q.discountAmt || 0,
                  discountAmtEnabled: q.discountAmtEnabled || false,
                  discountByQuantitiesEnabled:
                    q.discountByQuantitiesEnabled || false,
                  discountsByQuantities: q.discountsByQuantities || [],
                  purchaseAmount: Number(q.purchaseAmount) || 0,
                  purchaseDiscountAmt: q.purchaseDiscountAmt || 0,
                });
              });
              return Array.from(uniqueByType.values());
            })(),
          };
        })
        .filter((p: any) => p.variant);

      if (!productTemp.length) {
        setLoading(false);
        error("Please add at least one product");
        return;
      }

      productTemp.forEach((product: any, index: number) => {
        const hasValidQuantityType = (product.quantityTypes || []).some(
          (quantityType: any) => {
            const stockCount = Number(quantityType.stockCount) || 0;
            return stockCount > 0;
          },
        );
        productValidationTemp[index] = {
          variant: !product.variant || !hasValidQuantityType,
          quantityTypes: !hasValidQuantityType,
        };
      });
      setProductValidation(productValidationTemp);
      setProducts(productTemp);

      if (
        productValidationTemp.some(
          (pv: any) => pv.quantityTypes || pv.variant,
        )
      ) {
        setLoading(false);
        error("Please fill stock quantity for all products");
        return;
      }

      if (!variants.length || variants.every((v) => !v.quantityTypes.length)) {
        setLoading(false);
        error("Please add at least one product with quantity");
        return;
      }

      const deliveryDateCopy = new Date(deliveryDate);
      const params: any = {
        // uTrade addShipment reads `record`; uProcure uses `recordId` — send both
        record: recordId,
        recordId,
        shipment: {
          type: shipmentType,
          date: new Date(
            deliveryDateCopy.setHours(12, 0, 0, 0),
          ).toISOString(),
        },
        type: 1,
        shipmentFor: 1,
        businessActivationDate:
          businessActivationDate ||
          sellerData.find((s: any) => s._id === sellerId)?.KYC
            ?.profileUpdatedAt ||
          null,
        businessId: sellerId,
        warehouse: warehouseId,
        warehouseId,
        variants,
      };

      const apiService = new APICallService(
        PURCHASEORDER.addPurchaseOrder,
        params,
        {
          id: sellerId,
        },
        "",
        "",
        "",
        WarehouseManger,
        warehouseId,
      );

      const response = await apiService.callAPI();
      if (response) {
        navigate("/UProcure/purchase-order-management/purchase-order-details", {
          state: {
            id: recordId,
            status: poDetails?.status ?? state?.status,
          },
        });
      }
    } catch (err) {
      console.error("Error updating purchase order:", err);
    } finally {
      setLoading(false);
    }
  };

  const [costDetails, setCostDetails] = useState<any>({
    totalQuantities: [],
    totalWeight: 0,
    costInfo: {
      fees: [],
      charge: 0,
    },
  });

  const calculateCostDetails = () => {
    let totalQuantities: any = [];
    let totalWeight = 0;
    let totalCost = 0;

    products.forEach((product) => {
      product.quantityTypes.forEach((quantityType: any) => {
        if (quantityType.stockCount > 0) {
          totalQuantities.push({
            quantityType: quantityType.type,
            stockCount: quantityType.stockCount,
          });
          const weightPerUnit = 1;
          const costPerUnit = 100;
          totalWeight += weightPerUnit * quantityType.stockCount;
          totalCost += costPerUnit * quantityType.stockCount;
        }
      });
    });

    setCostDetails({
      totalQuantities,
      totalWeight,
      costInfo: {
        fees: [
          {
            type: WarehouseStorage,
            amount: totalCost * 0.1,
            discountAmt: 0,
            discountReason: null,
          },
          {
            type: Shipping,
            amount: totalCost * 0.05,
            discountAmt: 0,
            discountReason: null,
          },
        ],
        charge: totalCost + totalCost * 0.1 + totalCost * 0.05,
      },
    });
  };

  useEffect(() => {
    calculateCostDetails();
  }, [products]);

  useEffect(() => {
    const newWarehouses: any[] = umartData ? uTradeWarehouses : uMartWarehouses;
    setWarehouseData(newWarehouses);

    if (
      !selectedWarehouse ||
      !newWarehouses.some(
        (w: any) =>
          w._id === selectedWarehouse || w.reference === selectedWarehouse,
      )
    ) {
      setSelectedWarehouse(
        newWarehouses[0]?._id || newWarehouses[0]?.reference || "",
      );
    }
  }, [umartData, uTradeWarehouses, uMartWarehouses, selectedWarehouse]);

  useEffect(() => {
    if (!selectedWarehouse) return;
    products.forEach((product, index) => {
      if (product?.variant) {
        fetchProductPrice(product.variant, index);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWarehouse]);

  useEffect(() => {
    (async () => {
      let details = state;
      if (state?.id) {
        const response = await fetchPurchaseOrderInfo(state.id);
        details = response || state;
      }

      await Promise.all([getUTradeWarehouseList(), getUMartWarehouseList()]);

      const detailWarehouseRef =
        details?.warehouse?.reference || details?.warehouse?._id || "";
      if (detailWarehouseRef) {
        setSelectedWarehouse(detailWarehouseRef);
      }

      const resolvedDeliveryDate = parseDeliveryDate(
        details?.shipment?.date ||
          details?.deliveryDate ||
          details?.shipment?.deliveryDate,
      );
      setDeliveryDate(resolvedDeliveryDate);

      setBusinessActivationDate(details?.businessActivationDate || "");
      setShipmentType(details?.shipment?.type || UTradeTransport);

      if (details?.business) {
        const sellerId = details?.business?.reference || details?.business?._id;
        const sellers = await fetchSeller(1, PAGE_LIMIT, "");
        const matchedSeller = (sellers || []).find(
          (s: any) => (s?._id || s?.reference) === sellerId,
        );

        const sellerOption = {
          label:
            matchedSeller?.name ||
            matchedSeller?.ownerName ||
            matchedSeller?.title ||
            details?.business?.name ||
            details?.business?.ownerName ||
            details?.business?.title ||
            "",
          value: sellerId,
          title:
            matchedSeller?.name ||
            matchedSeller?.ownerName ||
            matchedSeller?.title ||
            details?.business?.name ||
            details?.business?.ownerName ||
            details?.business?.title ||
            "",
          creationDate:
            matchedSeller?._createdAt || details?.business?._createdAt,
        };
        setSelectedSeller(sellerOption);
        if (sellerOption.value) {
          await fetchProducts(sellerOption.value, 1, PAGE_LIMIT, "");
        }
      } else {
        await fetchSeller(1, PAGE_LIMIT, "");
      }

      if (details?.variants?.length) {
        const mappedProducts = details.variants.map((item: any) => {
          const variantId =
            item?.variant?._id ||
            item?.variant?.reference ||
            (typeof item?.variant === "string" ? item.variant : "") ||
            "";
          return {
            variant: variantId,
            quantityTypes: (item?.quantityTypes || []).map((qty: any) => ({
              ...qty,
              stockCount: qty?.stockCount || 0,
            })),
            selectedOption: {
              value: variantId,
              title: item?.variantName || item?.variant?.title || "",
              label: (
                <>
                  <div className="symbol symbol-30px border me-3">
                    <img
                      src={item?.media?.[0]?.url || item?.variant?.media?.[0]?.url}
                      className="object-fit-contain"
                      alt=""
                    />
                  </div>
                  <span className="fs-16 fw-600 text-black mb-0">
                    {(item?.variantName || item?.variant?.title || "").replace(
                      /\s*\)\s*/g,
                      ")",
                    )}
                  </span>
                </>
              ),
            },
          };
        });

        setProducts(mappedProducts);
        setPriceLoading(mappedProducts.map(() => false));
        setProductValidation(
          mappedProducts.map(() => ({
            variant: false,
            quantityTypes: false,
          })),
        );
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="p-5">
        <div className="mb-7">
          <h1 className="fs-22 fw-bolder">Edit Purchase Order</h1>
        </div>
        <Card className="border bg-f9f9f9 mb-5">
          <Card.Body>
            <Row className="align-items-center">
              <Col md={6} lg={6} className="mb-5">
                <Form.Label className="fs-16 fw-500">Supplier</Form.Label>
                <CustomSelect
                  value={selectedSeller}
                  disabled
                  isLoading={fetchLoader || loading || productFetchLoader}
                  options={
                    sellerData && sellerData.length
                      ? sellerData.map((val: any) => {
                          return {
                            label: (
                              <>
                                <div className="symbol symbol-30px border me-3">
                                  <img
                                    src={val.image}
                                    className="object-fit-contain"
                                    alt=""
                                  />
                                </div>
                                <span className="fs-16 fw-600 text-black mb-0">
                                  {val.ownerName}
                                </span>
                              </>
                            ),
                            value: val._id,
                            creationDate: val._createdAt,
                            title: val.ownerName,
                          };
                        })
                      : []
                  }
                  isDisabled={loading}
                />
              </Col>
              <Col md={6} lg={6} className="mb-5">
                <Form.Label className="fs-16 fw-500 text-dark pb-2">
                  Requested for
                </Form.Label>
                <div className="d-flex flex-wrap gap-2">
                  <div className="form-check form-check-custom form-check-solid me-6 mb-lg-0">
                    <input
                      className="form-check-input h-30px w-30px h-md-35px w-md-35px"
                      type="checkbox"
                      checked={umartData}
                      onChange={() => {
                        setUmartData(true);
                      }}
                      disabled
                    />
                    <label className="form-check-label text-dark fs-16 fw-600 ms-3">
                      U-Trade
                    </label>
                  </div>
                  <div className="form-check form-check-custom form-check-solid me-6 mb-lg-0">
                    <input
                      className="form-check-input h-30px w-30px h-md-35px w-md-35px"
                      type="checkbox"
                      checked={!umartData}
                      onChange={() => {
                        setUmartData(false);
                      }}
                      disabled
                    />
                    <label className="form-check-label text-dark fs-16 fw-600 ms-3">
                      U-Mart
                    </label>
                  </div>
                </div>
              </Col>
              <Col md={6} lg={6} className="mb-5">
                <Form.Label className="fs-16 fw-500">
                  Select Warehouse
                </Form.Label>
                <CustomSelect
                  disabled
                  isLoading={fetchLoader}
                  value={
                    warehouseData.find(
                      (w: any) =>
                        w._id === selectedWarehouse ||
                        w.reference === selectedWarehouse,
                    )
                      ? {
                          label: warehouseData.find(
                            (w: any) =>
                              w._id === selectedWarehouse ||
                              w.reference === selectedWarehouse,
                          )?.name,
                          value: selectedWarehouse,
                          title: warehouseData.find(
                            (w: any) =>
                              w._id === selectedWarehouse ||
                              w.reference === selectedWarehouse,
                          )?.name,
                        }
                      : null
                  }
                  options={
                    warehouseData && warehouseData.length
                      ? warehouseData.map((val: any) => ({
                          label: val.name,
                          value: val._id || val.reference,
                          title: val.name,
                        }))
                      : []
                  }
                />
              </Col>
              <Col md={6} lg={6} className="mb-5">
                <Form.Label className="fs-16 fw-500 text-dark pb-2">
                  Transportation service provided by
                </Form.Label>
                <div className="d-flex flex-wrap gap-2">
                  <div className="form-check form-check-custom form-check-solid me-6 mb-lg-0">
                    <input
                      className="form-check-input h-30px w-30px h-md-35px w-md-35px"
                      type="radio"
                      checked={shipmentType === UTradeTransport}
                      onChange={() => setShipmentType(UTradeTransport)}
                      disabled={loading}
                    />
                    <label className="form-check-label text-dark fs-16 fw-600 ms-3">
                      U Trade transport service
                    </label>
                  </div>
                  <div className="form-check form-check-custom form-check-solid me-6 mb-lg-0">
                    <input
                      className="form-check-input h-30px w-30px h-md-35px w-md-35px"
                      type="radio"
                      checked={shipmentType === SelfTransport}
                      onChange={() => setShipmentType(SelfTransport)}
                      disabled={loading}
                    />
                    <label className="form-check-label text-dark fs-16 fw-600 ms-3">
                      Supplier Transport
                    </label>
                  </div>
                </div>
              </Col>
              <Col md={6} lg={6} className="mb-5">
                <Form.Label className="fs-16 fw-500 text-dark">
                  Delivery date
                </Form.Label>
                <CustomDatePicker
                  className="form-control bg-white min-h-30px fs-16 fw-bold text-dark min-w-md-288px min-w-175px"
                  onChange={handleDateChange}
                  selected={deliveryDate}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Select delivery date"
                  isClearable={true}
                  inputTextBG="bg-white"
                  disabled={!selectedSeller?.value}
                  filterDate={isDateDisabled}
                />
              </Col>
            </Row>
          </Card.Body>
        </Card>
        {!selectedSeller?.value ? (
          <Card className="border bg-f9f9f9 mb-9">
            <Card.Header className="border-bottom-0">
              <Card.Title className="fs-22 fw-bolder">
                Products & Quantities
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <div className="fs-18 fw-500 text-center min-h-50px">
                Please select a seller to see products.
              </div>
            </Card.Body>
          </Card>
        ) : (
          <>
            <Card className="border bg-f9f9f9 py-3">
              <Card.Header className="border-bottom-0 mb-3">
                <Card.Title className="fs-22 fw-bolder">
                  Products & Quantities
                </Card.Title>
              </Card.Header>
              <Card.Body className="pt-0 pb-5">
                <>
                  {productFetchLoader ? (
                    <>
                      <div className="fs-18 fw-500 text-center min-h-50px">
                        <Loader loading={productFetchLoader} />
                      </div>
                    </>
                  ) : (
                    <>
                      {products.length ? (
                        <>
                          {products.map((val: any, index: number) => {
                            const isPriceLoading = priceLoading[index];
                            return (
                              <Fragment key={val.variant || index}>
                                <Row className="g-3 g-lg-5">
                                  <Col xs={12} md={4} lg={4}>
                                    <Form.Label className="fs-16 fw-500">
                                      Select product
                                    </Form.Label>
                                    <CustomSelect
                                      backgroundColor="#ffff"
                                      isLoading={productFetchLoader}
                                      options={
                                        sellerProducts && sellerProducts.length
                                          ? sellerProducts
                                              .filter(
                                                (item: any) =>
                                                  !products.some(
                                                    (p: any, pIndex: number) =>
                                                      p.variant === item._id &&
                                                      pIndex !== index,
                                                  ),
                                              )
                                              .map((item: any) => ({
                                                label: (
                                                  <>
                                                    <div className="symbol symbol-30px border me-3">
                                                      <img
                                                        src={
                                                          item?.media?.[0]?.url
                                                        }
                                                        className="object-fit-contain"
                                                        alt=""
                                                      />
                                                    </div>
                                                    <span className="fs-16 fw-600 text-black mb-0">
                                                      {item.title.replace(
                                                        /\s*\)\s*/g,
                                                        ")",
                                                      )}
                                                    </span>
                                                  </>
                                                ),
                                                value: item._id,
                                                title: `${item.title} ${productSearchTerm}`,
                                              }))
                                          : []
                                      }
                                      value={val?.selectedOption || null}
                                      onMenuScrollToBottom={
                                        onMenuProductScrollToBottom
                                      }
                                      onMenuClose={onMenuProductClose}
                                      onMenuOpen={onMenuProductOpen}
                                      onInputChange={(
                                        newValue: any,
                                        { action }: any,
                                      ) => {
                                        if (action === "input-change") {
                                          handleProductInputChange(newValue);
                                        }
                                      }}
                                      onChange={(event: any) => {
                                        handleProductSelect(event, index);
                                      }}
                                      isDisabled={loading}
                                    />
                                  </Col>

                                  {val.quantityTypes ? (
                                    <>
                                      <Col
                                        xs={12}
                                        md={8}
                                        lg={8}
                                        style={{ position: "relative" }}
                                      >
                                        <Form.Label className="fs-16 fw-500">
                                          Quantity
                                        </Form.Label>
                                        <Row className="align-items-start g-2 g-md-3">
                                          <Col xs={12} sm={6} md={4} lg={4}>
                                            {(() => {
                                              const arr =
                                                val.quantityTypes || [];
                                              const qIdx = arr.findIndex(
                                                (item: any) =>
                                                  item.type ===
                                                    CartonWithDozens ||
                                                  item.type ===
                                                    CartonWithPieces,
                                              );
                                              const qt = arr[qIdx];
                                              const isEnabled = qIdx !== -1;
                                              return (
                                                <>
                                                  <InputGroup
                                                    className="border border-r8px overflow-hidden p-0"
                                                    style={{ minWidth: 0 }}
                                                  >
                                                    <Form.Control
                                                      className="form-control-custom fs-16 fw-600 border-0 text-end bg-white"
                                                      style={{
                                                        padding:
                                                          "0.825rem 0.5rem 0.825rem 1rem",
                                                      }}
                                                      placeholder="cartons"
                                                      value={
                                                        qt?.stockCount ?? ""
                                                      }
                                                      onChange={(
                                                        event: any,
                                                      ) => {
                                                        const v = (
                                                          (event &&
                                                            event.target &&
                                                            event.target
                                                              .value) ||
                                                          ""
                                                        )
                                                          .toString()
                                                          .trimStart();
                                                        handleQuantityChange(
                                                          v,
                                                          index,
                                                          qIdx,
                                                          qt?.type ??
                                                            CartonWithPieces,
                                                        );
                                                      }}
                                                      type="number"
                                                      disabled={
                                                        !isEnabled ||
                                                        isPriceLoading
                                                      }
                                                    />
                                                    <InputGroup.Text
                                                      className={clsx(
                                                        "fs-16 fw-600 bg-white border-0 px-3",
                                                        isEnabled
                                                          ? "text-dark"
                                                          : "text-gray",
                                                      )}
                                                    >
                                                      {isPriceLoading ? (
                                                        <span className="spinner-border spinner-border-sm" />
                                                      ) : (
                                                        "cartons"
                                                      )}
                                                    </InputGroup.Text>
                                                  </InputGroup>
                                                  <div className="mt-2">
                                                    <InputGroup
                                                      className="border border-r8px overflow-hidden p-0"
                                                      style={{ minWidth: 0 }}
                                                    >
                                                      <Form.Control
                                                        className="form-control-custom fs-14 fw-600 border-0 text-end bg-white"
                                                        style={{
                                                          padding:
                                                            "0.5rem 0.5rem 0.5rem 1rem",
                                                        }}
                                                        placeholder="price"
                                                        value={
                                                          qt?.purchaseAmount ??
                                                          ""
                                                        }
                                                        readOnly
                                                        type="number"
                                                        disabled={
                                                          !isEnabled ||
                                                          !(
                                                            qt?.stockCount > 0
                                                          ) ||
                                                          isPriceLoading
                                                        }
                                                      />
                                                      <InputGroup.Text
                                                        className={clsx(
                                                          "fs-16 fw-600 bg-white border-0 px-3",
                                                          isEnabled
                                                            ? "text-dark"
                                                            : "text-gray",
                                                        )}
                                                      >
                                                        {isPriceLoading ? (
                                                          <span className="spinner-border spinner-border-sm" />
                                                        ) : (
                                                          "price"
                                                        )}
                                                      </InputGroup.Text>
                                                    </InputGroup>
                                                  </div>
                                                </>
                                              );
                                            })()}
                                          </Col>

                                          <Col xs={12} sm={6} md={4} lg={4}>
                                            {(() => {
                                              const arr =
                                                val.quantityTypes || [];
                                              const qIdx = arr.findIndex(
                                                (item: any) =>
                                                  item.type === Dozen,
                                              );
                                              const qt = arr[qIdx];
                                              const isEnabled = qIdx !== -1;
                                              return (
                                                <>
                                                  <InputGroup
                                                    className="border border-r8px overflow-hidden p-0"
                                                    style={{ minWidth: 0 }}
                                                  >
                                                    <Form.Control
                                                      className="form-control-custom fs-16 fw-600 border-0 text-end bg-white"
                                                      style={{
                                                        padding:
                                                          "0.825rem 0.5rem 0.825rem 1rem",
                                                      }}
                                                      placeholder="dozens"
                                                      value={
                                                        qt?.stockCount ?? ""
                                                      }
                                                      onChange={(
                                                        event: any,
                                                      ) => {
                                                        const v = (
                                                          (event &&
                                                            event.target &&
                                                            event.target
                                                              .value) ||
                                                          ""
                                                        )
                                                          .toString()
                                                          .trimStart();
                                                        handleQuantityChange(
                                                          v,
                                                          index,
                                                          qIdx,
                                                          Dozen,
                                                        );
                                                      }}
                                                      type="number"
                                                      disabled={
                                                        !isEnabled ||
                                                        isPriceLoading
                                                      }
                                                    />
                                                    <InputGroup.Text
                                                      className={clsx(
                                                        "fs-16 fw-600 bg-white border-0 px-3",
                                                        isEnabled
                                                          ? "text-dark"
                                                          : "text-gray",
                                                      )}
                                                    >
                                                      {isPriceLoading ? (
                                                        <span className="spinner-border spinner-border-sm" />
                                                      ) : (
                                                        "dozens"
                                                      )}
                                                    </InputGroup.Text>
                                                  </InputGroup>
                                                  <div className="mt-2">
                                                    <InputGroup
                                                      className="border border-r8px overflow-hidden p-0"
                                                      style={{ minWidth: 0 }}
                                                    >
                                                      <Form.Control
                                                        className="form-control-custom fs-14 fw-600 border-0 text-end bg-white"
                                                        style={{
                                                          padding:
                                                            "0.5rem 0.5rem 0.5rem 1rem",
                                                        }}
                                                        placeholder="price"
                                                        value={
                                                          qt?.purchaseAmount ??
                                                          ""
                                                        }
                                                        readOnly
                                                        type="number"
                                                        disabled={
                                                          !isEnabled ||
                                                          !(
                                                            qt?.stockCount > 0
                                                          ) ||
                                                          isPriceLoading
                                                        }
                                                      />
                                                      <InputGroup.Text
                                                        className={clsx(
                                                          "fs-16 fw-600 bg-white border-0 px-3",
                                                          isEnabled
                                                            ? "text-dark"
                                                            : "text-gray",
                                                        )}
                                                      >
                                                        {isPriceLoading ? (
                                                          <span className="spinner-border spinner-border-sm" />
                                                        ) : (
                                                          "price"
                                                        )}
                                                      </InputGroup.Text>
                                                    </InputGroup>
                                                  </div>
                                                </>
                                              );
                                            })()}
                                          </Col>

                                          <Col xs={12} sm={6} md={4} lg={4}>
                                            {(() => {
                                              const arr =
                                                val.quantityTypes || [];
                                              const qIdx = arr.findIndex(
                                                (item: any) =>
                                                  item.type === Piece,
                                              );
                                              const qt = arr[qIdx];
                                              const isEnabled = qIdx !== -1;
                                              return (
                                                <>
                                                  <InputGroup
                                                    className="border border-r8px overflow-hidden p-0"
                                                    style={{ minWidth: 0 }}
                                                  >
                                                    <Form.Control
                                                      className="form-control-custom fs-16 fw-600 border-0 text-end bg-white"
                                                      style={{
                                                        padding:
                                                          "0.825rem 0.5rem 0.825rem 1rem",
                                                      }}
                                                      placeholder="pieces"
                                                      value={
                                                        qt?.stockCount ?? ""
                                                      }
                                                      onChange={(
                                                        event: any,
                                                      ) => {
                                                        const v = (
                                                          (event &&
                                                            event.target &&
                                                            event.target
                                                              .value) ||
                                                          ""
                                                        )
                                                          .toString()
                                                          .trimStart();
                                                        handleQuantityChange(
                                                          v,
                                                          index,
                                                          qIdx,
                                                          Piece,
                                                        );
                                                      }}
                                                      type="number"
                                                      disabled={
                                                        !isEnabled ||
                                                        isPriceLoading
                                                      }
                                                    />
                                                    <InputGroup.Text
                                                      className={clsx(
                                                        "fs-16 fw-600 bg-white border-0 px-3",
                                                        isEnabled
                                                          ? "text-dark"
                                                          : "text-gray",
                                                      )}
                                                    >
                                                      {isPriceLoading ? (
                                                        <span className="spinner-border spinner-border-sm" />
                                                      ) : (
                                                        "pieces"
                                                      )}
                                                    </InputGroup.Text>
                                                  </InputGroup>
                                                  <div className="mt-2">
                                                    <InputGroup
                                                      className="border border-r8px overflow-hidden p-0"
                                                      style={{ minWidth: 0 }}
                                                    >
                                                      <Form.Control
                                                        className="form-control-custom fs-14 fw-600 border-0 text-end bg-white"
                                                        style={{
                                                          padding:
                                                            "0.5rem 0.5rem 0.5rem 1rem",
                                                        }}
                                                        placeholder="price"
                                                        value={
                                                          qt?.purchaseAmount ??
                                                          ""
                                                        }
                                                        readOnly
                                                        type="number"
                                                        disabled={
                                                          !isEnabled ||
                                                          !(
                                                            qt?.stockCount > 0
                                                          ) ||
                                                          isPriceLoading
                                                        }
                                                      />
                                                      <InputGroup.Text
                                                        className={clsx(
                                                          "fs-16 fw-600 bg-white border-0 px-3",
                                                          isEnabled
                                                            ? "text-dark"
                                                            : "text-gray",
                                                        )}
                                                      >
                                                        {isPriceLoading ? (
                                                          <span className="spinner-border spinner-border-sm" />
                                                        ) : (
                                                          "price"
                                                        )}
                                                      </InputGroup.Text>
                                                    </InputGroup>
                                                  </div>
                                                </>
                                              );
                                            })()}
                                          </Col>
                                        </Row>

                                        {productValidation[index]
                                          .quantityTypes ? (
                                          <Form.Label className="fs-12 fw-500 mt-2 text-danger">
                                            At least one stock must have a value
                                            greater than 0.
                                          </Form.Label>
                                        ) : null}
                                        {productValidation[index].variant ? (
                                          <Form.Label className="fs-12 fw-500 mt-2 text-danger">
                                            Price must have a value greater than
                                            0.
                                          </Form.Label>
                                        ) : null}

                                        {products.length > 1 && (
                                          <Button
                                            variant="link"
                                            className="btn-flush"
                                            onClick={() => {
                                              handleRemove(index);
                                            }}
                                            style={{
                                              position: "absolute",
                                              right: 0,
                                              top: 0,
                                            }}
                                          >
                                            <img
                                              width={15}
                                              height={15}
                                              className="img-fluid"
                                              src={GrayCross}
                                              alt=""
                                            />
                                          </Button>
                                        )}
                                      </Col>
                                    </>
                                  ) : (
                                    <Col xs={11} md={6} lg={8}></Col>
                                  )}
                                </Row>

                                {index === products.length - 1 ? (
                                  <>
                                    {sellerProducts && sellerProducts.length ? (
                                      sellerProducts.filter(
                                        (item: any) =>
                                          !products.some(
                                            (p: any) => p.variant === item._id,
                                          ),
                                      ).length ? (
                                        <Row className="d-flex justify-content-start">
                                          <Col className="d-flex justify-content-start mt-13">
                                            <Button
                                              variant="link"
                                              className="btn-flush "
                                              disabled={loading}
                                              onClick={() => {
                                                handleAddMore();
                                              }}
                                            >
                                              <span className="text-primary fs-16 fw-600">
                                                + Add new product
                                              </span>
                                            </Button>
                                          </Col>
                                        </Row>
                                      ) : null
                                    ) : null}
                                  </>
                                ) : (
                                  <div className="separator my-6"></div>
                                )}
                              </Fragment>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          <div className="fs-18 fw-500 text-center min-h-50px">
                            No products available
                          </div>
                        </>
                      )}
                    </>
                  )}
                </>
              </Card.Body>
            </Card>
          </>
        )}
        {/* BUTTON */}
        <div className="d-flex justify-content-end  mt-6">
          <Button
            size="lg"
            className="uw-btn uw-btn-primary uw-btn-lg min-h-lg-60px"
            onClick={() => handleSubmit()}
            disabled={loading}
          >
            {!loading && (
              <span className="indicator-label fs-16 fw-bold">
                Confirm request
              </span>
            )}
            {loading && (
              <span
                className="indicator-progress fs-16 fw-bold"
                style={{ display: "block" }}
              >
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </Button>
        </div>
      </div>
    </>
  );
};
export default EditPurchaseOrder;
